import {useEffect} from 'react';
import {emitPageView} from '@di-shared/features/analytics/index';
import {useMatches} from 'react-router';

export interface AnalyticPageViewProps {
  screenName?: string;
}

function AnalyticPageView({screenName}: AnalyticPageViewProps) {
  const matches = useMatches();

  useEffect(() => {
    emitPageView(screenName || matches[matches.length - 1].id);
  }, [matches, screenName]);
  return null;
}

export default AnalyticPageView;
